module.exports = __webpack_public_path__ + "media/images/athletes/4333-ca5a66b13cf81386e97875747b6477e4.png";